<mat-dialog-content class="adap-dialog-content">
    <app-dialog-header [title]="title"></app-dialog-header>
    <ng-container *ngIf="formState$ | async as formState">
    <form #form novalidate [ngrxFormState]="formState" class="adap-form-container">
        <div class="form-row-2-columns">
            <app-input-container
            label="title"
            [app-input-validation-container]="formState.controls.title!"
            [isRequired]="true"
            >
                <input
                class="adap-form-input" 
                [ngrxFormControlState]="formState.controls.title!"
                placeholder="title"
                />
            </app-input-container>
            <app-input-container
            label="drs code"
            [app-input-validation-container]="formState.controls.drsCode!"
            [isRequired]="true"
            >
                <input
                class="adap-form-input" 
                [ngrxFormControlState]="formState.controls.drsCode!"
                placeholder="drs code"
                />
            </app-input-container>
            <app-input-container
            label="deliverable id"
            [app-input-validation-container]="formState.controls.deliverableId!"
            >
                <input
                class="adap-form-input" 
                [ngrxFormControlState]="formState.controls.deliverableId!"
                placeholder="deliverable id"
                />
            </app-input-container>
            <app-input-container
            label="doc type"
            [isRequired]="true"
            [app-input-validation-container]="formState.controls.docType!"
            >
            <mat-form-field class="adap-select" appearance="outline">
                <mat-select
                [ngrxFormControlState]="formState.controls.docType!"
                placeholder="doc type"
                >
                <ng-container *ngFor="let docType of docTypes">
                    <mat-option [value]="docType">{{ docType }}</mat-option>
                </ng-container>
                </mat-select>
            </mat-form-field>
            </app-input-container>
            <app-input-container
            label="discipline"
            [isRequired]="true"
            [app-input-validation-container]="formState.controls.deliverableDiscipline!"
            >
            <mat-form-field class="adap-select" appearance="outline">
                <mat-select
                [ngrxFormControlState]="formState.controls.deliverableDiscipline!"
                placeholder="discipline"
                >
                <ng-container *ngFor="let code of smeDisciplineConfigCodes$ | async">
                    <mat-option [value]="code">{{ code }}</mat-option>
                </ng-container>
                </mat-select>
            </mat-form-field>
            </app-input-container>
            <div class="checkbox-container">
                <div class="section-input">
                    <mat-checkbox
                        color="primary"
                        [ngrxFormControlState]="
                        formState.controls.onshore!
                        "
                    >
                        onshore
                    </mat-checkbox>
                </div>
                <div class="section-input">
                    <mat-checkbox
                        color="primary"
                        [ngrxFormControlState]="
                        formState.controls.offshore!
                        "
                    >
                        offshore
                    </mat-checkbox>
                </div>
            </div>

        </div>
        <app-input-container
            label="definition"
            [characterCounterLength]="formState.controls.definition!.value?.length ?? 0"
            [characterCounterMaxLength]="DEFINITION_MAX_LENGTH"
            [app-input-validation-container]="formState.controls.definition!"
        >
            <textarea
            id="scopeOfReview"
            name="scopeOfReview"
            type="text"
            class="adap-form-textarea text-area-container"
            [ngrxFormControlState]="formState.controls.definition!"
            >
            </textarea>
        </app-input-container>

        <app-input-container
        label="phases"
        [isRequired]="false"
        [app-input-validation-container]="formState.controls.phaseGuidelines"
        >
        <mat-form-field class="adap-select" appearance="outline">
            <mat-select
            multiple
            [ngrxFormControlState]="formState.controls.phaseGuidelines"
            placeholder="select phases"
            >
                <ng-container *ngFor="let phase of phases$ | async">
                    <mat-option [value]="phase">{{ phase }}</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
</app-input-container>

    </form>
    <div class="dialog-actions">
        <button class="adap-btn-outline" type="button" (click)="closeWindow()">
            cancel
        </button>
        <ng-container>
            <ng-container>
            <button
                class="adap-btn-filled"
                type="button"
                [disabled]="!formState.isValid"
                (click)="save()"
            >
            save
            </button>
            </ng-container>
        </ng-container>
    </div>
    </ng-container>
</mat-dialog-content>
